

/*
  _____                .___.__                             
  _/ ____\___________  __| _/|__|   ____________ ___________ 
  \   __\/ __ \_  __ \/ __ | |  |  /  _ \___   // __ \_  __ \
   |  | \  ___/|  | \/ /_/ | |  | (  <_> )    /\  ___/|  | \/
   |__|  \___  >__|  \____ | |__|  \____/_____ \\___  >__|   
             \/           \/                  \/    \/       
                                                ferdiozer.com
*/

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

//language
import './i18n'

ReactDOM.render(<App />, document.getElementById('root'));
